export default "__VITE_ASSET__DxA9eLnW__"